export default __webpack_public_path__ + "static/media/home-foto-testimonios-viajes-profile-tower-Incoming-desk-1@2x.a94fecf3.jpg";